import { useCallback } from 'react';

import {
  boardSwitcherSearchSharedState,
  boardSwitcherSharedState,
} from '@trello/board-switcher';
import { useFeatureGate } from '@trello/feature-gate-client';
import { useOpenBoardPanel } from '@trello/split-screen';

export const useOpenBoardAndHideSwitcher = () => {
  const openBoardPanel = useOpenBoardPanel();

  const { value: isBoardSwitcherPanelEnabled } = useFeatureGate(
    'billplat_board_switcher_panel',
  );

  return useCallback(() => {
    if (isBoardSwitcherPanelEnabled) return;

    openBoardPanel();
    boardSwitcherSharedState.setValue({
      isOpen: false,
    });
    boardSwitcherSearchSharedState.setValue({
      query: null,
    });
  }, [isBoardSwitcherPanelEnabled, openBoardPanel]);
};
